/* eslint-disable camelcase */
export default {
    en: {
        title: 'Career Portal',
        navigationItem: {
            'ai-assistant': 'AI Assistant',
            'opportunities': 'Opportunities',
            'profile': 'Profile',
            'availability': 'Calendar',
            'requestForOpportunities': 'Ask for Opportunities',
            'jobPreferences': 'Job Preferences',
            'my-jobs': 'My Jobs',

            'privacy': 'Privacy',
            'cookies': 'Cookies',
            'contacts': 'Contacts',
            'reportProblem': 'Report a problem'
        },
        reportProblem: {
            title: 'Report a problem',
            placeholder: 'Describe the problem you are experiencing...',
            cancel: 'Cancel',
            submit: 'Submit',
            success: 'Thank you! Your report has been submitted.',
            close: 'Close'
        },
        fallback: {
            label: 'Classic version',
            tooltip: 'Switch to classic version'
        },
        welcomeBanner: {
            title: 'Welcome to your career portal',
            title_offers: 'Find your next opportunity - fast',
            description: 'Keep your profile up to date and get matched with relevant shifts and projects.',
            description_offers: 'Keep your profile up to date, set your preferences, and get matched with relevant job opportunities.',
            description_profile: 'Manage your personal information, job preferences, and availability to get the best job matches.',
            description_availability: 'Update your availability to ensure you receive job opportunities that fit your schedule.',
            description_requestForOpportunities: 'Let us know what kind of job opportunities you are looking for, and we will help you find them.',
            description_updateJobPreferences: 'Update your job preferences to receive the most relevant job opportunities.',
            description_candidateAvailability: 'Update your availability to ensure you never miss out on job opportunities that fit your schedule.',
            'description_ai-assistant': 'Get personalized job recommendations and assistance using our AI-powered recruitment assistant.',
            bulletPoints: [ ],
            bulletPoints_offers: [ 'New jobs weekly', 'Short-term, long-term & flexible vacancies' ]
        }
    },
    no: {
        title: 'Karriereportal',
        navigationItem: {
            'ai-assistant': 'AI Assistant',
            'opportunities': 'Jobbmuligheter',
            'profile': 'Profil',
            'availability': 'Kalender',
            'requestForOpportunities': 'Spør etter muligheter',
            'jobPreferences': 'Jobbpreferanser',
            'my-jobs': 'Mine jobber',
            'contacts': 'Kontakt',

            'privacy': 'Personvern',
            'cookies': 'Cookies',
            'reportProblem': 'Rapporter et problem'
        },
        reportProblem: {
            title: 'Rapporter et problem',
            placeholder: 'Beskriv problemet du opplever...',
            cancel: 'Avbryt',
            submit: 'Send',
            success: 'Takk! Rapporten din er sendt.',
            close: 'Lukk'
        },
        fallback: {
            label: 'Klassisk Versjon',
            tooltip: 'Bytt til klassisk versjon'
        },
        welcomeBanner: {
            title: 'Velkommen til Karriereportalen',
            title_offers: 'Finn din neste jobbmulighet - raskt',
            description: 'Finn din neste mulighet her',
            description_offers: 'Hold profilen din oppdatert, angi preferansene dine, og bli matchet med relevante jobbmuligheter.',
            description_profile: 'Hold din personlige informasjon, jobbpreferanser og tilgjengelighet oppdatert for å få de beste jobbmatchene.',
            description_availability: 'Oppdater din tilgjengelighet for å sikre at du mottar jobbmuligheter som passer din timeplan.',
            description_requestForOpportunities: 'Gi oss beskjed om hva slags jobbmuligheter du leter etter, så hjelper vi deg med å finne dem.',
            description_updateJobPreferences: 'Oppdater dine jobbpreferanser for å motta de mest relevante jobbmulighetene.',
            description_candidateAvailability: 'Oppdater din tilgjengelighet for å sikre at du aldri går glipp av jobbmuligheter som passer din timeplan.',
            'description_ai-assistant': 'Få personlige jobb anbefalinger og assistanse ved hjelp av vår AI-drevne rekrutteringsassistent.',
            bulletPoints: [ ],
            bulletPoints_offers: [ 'Nye jobber hver uke', 'Korttids-, langsiktige og fleksible oppdrag' ]
        }
    },
    sv: {
        title: 'Karriärportal',
        navigationItem: {
            'ai-assistant': 'AI Assistant',
            'opportunities': 'Jobbmöjligheter',
            'profile': 'Profil',
            'availability': 'Kalender',
            'requestForOpportunities': 'Fråga efter möjligheter',
            'jobPreferences': 'Jobbpreferenser',
            'my-jobs': 'Mina jobb',
            'contacts': 'Kontakt',

            'privacy': 'Integritet',
            'cookies': 'Cookies',
            'reportProblem': 'Rapportera ett problem'
        },
        reportProblem: {
            title: 'Rapportera ett problem',
            placeholder: 'Beskriv problemet du upplever...',
            cancel: 'Avbryt',
            submit: 'Skicka',
            success: 'Tack! Din rapport har skickats.',
            close: 'Stäng'
        },
        fallback: {
            label: 'Klassisk Version',
            tooltip: 'Byt till klassisk version'
        },
        welcomeBanner: {
            title: 'Välkommen till Karriärportalen',
            title_offers: 'Hitta din nästa jobbmöjlighet - snabbt',
            description: 'Hitta din nästa möjlighet här',
            description_offers: 'Håll din profil uppdaterad, ange dina preferenser och matchas med relevanta jobbmöjligheter.',
            description_profile: 'Hantera din personliga information, jobbpreferenser och tillgänglighet för att få de bästa jobbmatchningarna.',
            description_availability: 'Ange din tillgänglighet för att säkerställa att du aldrig missar jobbmöjligheter som passar ditt schema.',
            description_requestForOpportunities: 'Låt oss veta vilka typer av jobbmöjligheter du letar efter, så hjälper vi dig att hitta dem.',
            description_updateJobPreferences: 'Uppdatera dina jobbpreferenser för att ta emot de mest relevanta jobbmöjligheterna.',
            description_candidateAvailability: 'Uppdatera din tillgänglighet för att säkerställa att du erbjuds jobbmöjligheter som passar ditt schema.',
            'description_ai-assistant': 'Få personliga jobbrekommendationer och assistans med hjälp av vår AI-drivna rekryteringsassistent.',
            bulletPoints: [ ],
            bulletPoints_offers: [ 'Nya jobb varje vecka', 'Korttids-, långsiktiga och flexibla uppdrag' ]
        }
    }
} as const;
